module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-warp",
    style: ({
      background: ("url(" + _vm.chinaBanbg + ")")
    }),
    attrs: {
      "id": "china-warp"
    }
  }, [_c('div', {
    staticClass: "swipe-wrap",
    attrs: {
      "id": "swiper"
    }
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "swiper-container"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('CarouselItem', {
      key: item.imgUrl
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "height": "412",
        "width": "1140"
      }
    })])], 1)
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da9b8086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/china-time-honored/banner.vue
// module id = 1669
// module chunks = 1